import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { createField } from 'bundles/apex/playbooks/config/store/playbooks/actions';

import { Button } from 'components/ui/button';
import ManagedFormGroup from 'components/form/managed_input/form_group';
import ManagedInput from 'components/form/managed_input';
import Modal from 'components/modal';

export function FieldModal({ createField, playbook, stage, onHide }) {
  const [name, setName] = useState();
  const [required, setRequired] = useState(false);
  const [saving, setSaving] = useState();

  const availableFields = useMemo(() => {
    const availableFields = [];
    for (const field of playbook.allFieldsByStage[stage]) {
      if (!playbook.fieldsByStage[stage].find(({ name }) => field.name === name)) {
        availableFields.push(field);
      }
    }
    return availableFields;
  });

  async function handleAdd() {
    setSaving(true);
    await createField(playbook, name, stage, required);
    onHide();
  }

  return (
    <Modal show onHide={onHide}>
      <Modal.Header closeButton>
        Add Field
      </Modal.Header>

      <Modal.Body>
        <ManagedFormGroup
          className="mb-3"
          includeBlank
          name="name"
          required
          type="select"
          value={name}
          onValueChange={setName}
        >
          {availableFields.map(field => (
            <option key={field.name} value={field.name}>
              {field.label}
            </option>
          ))}
        </ManagedFormGroup>

        <ManagedInput
          name="required"
          type="checkbox"
          value={required}
          onValueChange={setRequired}
        >
          Required
        </ManagedInput>
      </Modal.Body>

      <Modal.Footer>
        <Button name="cancel" variant="ghost" onClick={onHide}>
          Cancel
        </Button>
        <Button disabled={!name || saving} name="save" onClick={handleAdd}>
          Add
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

FieldModal.propTypes = {
  createField: PropTypes.func.isRequired,
  playbook: PropTypes.shape({
    allFieldsByStage: PropTypes.object.isRequired,
    fieldsByStage: PropTypes.object.isRequired,
  }).isRequired,
  stage: PropTypes.string.isRequired,
  onHide: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  createField,
};

export default connect(null, mapDispatchToProps)(FieldModal);
